const application = { 
    development: {
        profile: "development",
        server: "//39.103.143.136/sso-server/web/",
        login: {
            qq: {
                appid: "101961669",
                authorizeUrl: "https://graph.qq.com/oauth2.0/authorize",
                redirectUri: "http://test.coufran.cn/sso/qq.html"
            }
        },
        mock: {
            qq: false
        },
        debug: false
    },
    test: {
        profile: "test",
        server: "//test.server.coufran.cn/sso-server/web/",
        login: {
            qq: {
                appid: "101961669",
                authorizeUrl: "https://graph.qq.com/oauth2.0/authorize",
                redirectUri: "http://test.coufran.cn/sso/qq.html"
            }
        },
        mock: {
            qq: false
        },
        debug: true
    },
    production: {
        profile: "production",
        server: "//www.coufran.cn/sso-server/web/",
        login: {
            qq: {
                appid: "101961669",
                authorizeUrl: "https://graph.qq.com/oauth2.0/authorize",
                redirectUri: "https://www.coufran.cn/sso/qq.html"
            }
        },
        mock: {
            qq: false
        },
        debug: false
    }
};

export default application[process.env.VUE_APP_PROFILE_ACTIVE];